<template>
  <div class="serverForm">
    <template v-if="currServs.length">
      <h3 class="currServTitle">
        当前服务器类型<el-link @click="showAllCurrServs"
          >查看更多 <i class="el-icon-caret-bottom"></i>
        </el-link>
      </h3>
      <div class="currServers">
        <div
          v-for="(currServ, index) in currServs4Display"
          class="serverItem currServer"
          :key="index"
        >
          <img :src="getLevelImg(currServ.room_type)" />
          <div class="serverInfo">
            <h4>{{ currServ.id }}</h4>
            <p>
              {{ ROOM_TYPE[currServ.room_type] }}(最多容纳{{
                currServ.player_max
              }}人)
            </p>
            <p>剩余时间：{{ currServ.expire_time | remainderTime }}</p>
          </div>
        </div>
      </div>
    </template>
    <h3>选择服务器类型</h3>
    <div class="serverList">
      <div
        class="serverItem"
        :class="{
          selected: selectedIndex === index,
          disabled: item.room_type < miniLevel,
        }"
        v-for="(item, index) in price"
        :key="index"
        @click="handleServerClick(item, index, $event)"
      >
        <div class="serverInfo">
          <div class="serverDesc">
            <img :src="getLevelImg(item.room_type)" />
            <div class="serverInner">
              <h4>{{ ROOM_TYPE[item.room_type] }}</h4>
              <p>最多容纳{{ item.player_max }}人</p>
            </div>
          </div>
          <div class="serverPrice" v-if="item.sub_rmb">
            <span class="originPrice deleteLine"
              >¥ {{ item.rmb | toFixed }}</span
            >
            <span class="discountPrice">¥ {{ item.sub_rmb | toFixed }}</span>
          </div>
          <div class="serverPrice" v-else>
            <span class="originPrice">¥ {{ item.rmb | toFixed }}</span>
          </div>
        </div>
        <div class="serverDiscount" v-if="item.sub_rmb_txt">
          {{ item.sub_rmb_txt }}
        </div>
      </div>
    </div>
    <div v-show="!currServs.length">
      <h3>选择购买数量</h3>
      <el-input-number
        size="mini"
        v-model="buyCount"
        :min="min"
        :max="buyLimit - buyedCount"
      ></el-input-number>
    </div>
    <h3>选择时长</h3>
    <el-radio-group v-model="days" size="mini">
      <el-radio-button
        v-for="(item, index) in day"
        size="mini"
        :label="item"
        :key="index"
      >
        {{ item ? item + '天' : '不延长天数' }}
      </el-radio-button>
    </el-radio-group>
    <div class="line"></div>
    <div v-show="!hideForm">
      <el-form
        class="order"
        label-position="right"
        label-width="92px"
        v-loading="totalPriceLoading"
      >
        <el-form-item label="已选择：" v-if="miniLevel !== 5">
          <span v-if="selectedName"> {{ selectedName }}*{{ buyCount }} </span>
          <span v-else>未选择服务器</span>
        </el-form-item>
        <el-form-item label="购买时长："> {{ days }}天 </el-form-item>
        <el-form-item label="单价：" v-show="isSameLevel">
          {{ currItem.singlePrice
          }}<span style="color: #ff4433" v-if="currItem.singlePriceDesc">{{
            currItem.singlePriceDesc
          }}</span>
        </el-form-item>
        <el-form-item label="费用总计：" class="total-item">
          <div class="total">
            ¥{{ totalPrice }} <em v-show="subPrice">(已优惠¥{{ subPrice }})</em>
          </div>
        </el-form-item>
      </el-form>
      <div class="serverFromFooter">
        <el-checkbox v-model="agreeProto" type="primary">同意</el-checkbox>
        <el-link
          href="https://www.mini1.cn/article/20200119/1235.html"
          target="_blank"
          type="primary"
          >《迷你服务器协议》</el-link
        >
        <el-button
          type="primary"
          @click="handleSubmit"
          :disabled="!agreeProto || totalPriceLoading"
          :loading="totalPriceLoading"
          >提交订单</el-button
        >
      </div>
    </div>
    <el-dialog title="当前服务器类型" :visible.sync="dialogTableVisible">
      <el-table
        :data="currServs"
        max-height="400"
        stripe
        border
        :header-cell-style="{ backgroundColor: '#fafafa' }"
      >
        <el-table-column property="id" label="服务器ID"></el-table-column>
        <el-table-column property="room_type" label="服务器类型">
          <template slot-scope="scope">
            <span>{{ scope.row.room_type | roomType }}</span>
          </template>
        </el-table-column>
        <el-table-column property="stat" label="服务状态">
          <template slot-scope="scope">
            <span>{{ scope.row.stat | getStat }}</span>
          </template>
        </el-table-column>
        <el-table-column property="expire_time" label="剩余时间" width="200px">
          <template slot-scope="scope">
            <span>{{ scope.row.expire_time | remainderTime }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :visible.sync="showTip" center width="500px" :show-close="false">
      <template slot="title">
        <span class="tip-title">
          <i class="icon el-icon-warning"></i>温馨提示
        </span>
      </template>
      <div class="tip-contnet">
        <p>尊敬的迷你服务器用户：</p>
        <p class="p">我们预计8月版本更新的时候对迷你服务器进行升级优化，届时会对沙盒服务器的功能迭代更新，同时服务器的价格也会降价。</p>
        <p class="p">建议您非必要情况可以先购买短时天数。</p>
      </div>
      <span slot="footer">
        <el-button type="warning" @click="showTip = false">我已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixins from '../../mixins/serverOrder.mixins.js';

export default {
  mixins: [mixins],
  created() {
    if (this.$route.params.type === 'renew') {
      this.buyLimit = Math.max(
        this.buyLimit,
        this.$route.params.currServers
          ? this.$route.params.currServers.length
          : this.currServs.length,
      );
    }
  },
  mounted() {
    //服务器购买页曝光埋点
    this.cloudBuy();
  },
  methods: {
    showAllCurrServs() {
      this.dialogTableVisible = true;
    },
    cloudBuy() {
      this.$log('cloudservice_purchase_show', 85438, { v7: 1 });
    },
  },
};
</script>
<style lang="scss" scoped>
.serverForm {
  h3 {
    font-size: 18px;
    font-weight: 400;
    color: #262626;
    line-height: 25px;
    margin-bottom: 16px;
    &.currServTitle {
      display: flex;
      justify-content: space-between;
    }
  }
  .line {
    margin: 60px auto 30px;
    height: 1px;
    background: #d9d9d9;
  }
  .currServers {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 12px;
    .serverItem {
      // width: 352px;
      height: 90px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #e1e1e1;
      margin-bottom: 16px;
      margin-right: 16px;
      display: flex;
      flex-direction: row;
      padding: 10px;
      img {
        display: block;
        width: 70px;
        height: 70px;
        margin-right: 10px;
      }
      h4 {
        font-size: 16px;
        font-weight: 400;
        color: #262626;
        line-height: 22px;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: #878d99;
        line-height: 20px;
        margin-top: 4px;
      }
    }
  }
  .serverList {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-bottom: 28px;
    .serverItem {
      height: 129px;
      width: 236px;
      position: relative;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #e1e1e1;
      cursor: pointer;
      margin-right: 15px;
      margin-bottom: 15px;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .serverInfo {
        .serverDesc {
          display: flex;
          flex-direction: row;
          img {
            display: block;
            width: 90px;
            height: 90px;
            padding: 10px;
          }
          .serverInner {
            display: flex;
            flex-direction: column;
            justify-content: center;
            h4 {
              font-size: 16px;
              font-weight: 400;
              color: #262626;
              line-height: 22px;
              margin-bottom: 6px;
            }
            p {
              font-size: 14px;
              font-weight: 400;
              color: #878d99;
              line-height: 20px;
            }
          }
        }
      }
      .serverPrice {
        width: 216px;
        margin: 0 auto;
        padding: 10px 0;
        border-top: 1px solid #ebebeb;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
        .originPrice {
          font-size: 12px;
          font-weight: 400;
          color: #bfbfbf;
          line-height: 17px;
          margin-right: 20px;
          &.deleteLine {
            text-decoration: line-through;
          }
        }
        .discountPrice {
          font-size: 16px;
          font-weight: 600;
          color: #ff5533;
          line-height: 22px;
        }
      }
      .serverDiscount {
        width: 50px;
        height: 22px;
        background: linear-gradient(90deg, #ff9d85 0%, #ff4c38 100%);
        border-radius: 4px 10px 4px 10px;
        color: #fff;
        text-align: center;
        position: absolute;
        top: -11px;
        right: 0;
      }
      &.selected {
        background: rgba(255, 204, 64, 0.06);
        border: 1px solid #ffcc40;
      }
      &.disabled {
        opacity: 0.6;
        .serverInfo {
          .serverDesc {
            img {
              filter: grayscale(1);
            }
          }
        }
        .serverDiscount {
          background: linear-gradient(90deg, #ebebeb 0%, #cccccc 100%);
        }
      }
    }
  }
  .el-input-number {
    margin-bottom: 28px;
  }
  .el-radio-group {
    .el-radio-button {
      margin-right: 12px;
      ::v-deep .el-radio-button__inner {
        font-size: 12px;
        width: auto;
        height: 29px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #e1e1e1;
        box-shadow: none;
      }
      ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #323232;
        background: #fff9eb;
        border-color: #ffcc40;
      }
    }
  }
  .order {
    height: 164px;
    background: #f6f5f7;
    border-radius: 8px;
    padding: 16px 30px;
    margin-bottom: 20px;
    .el-form-item {
      margin: 0 auto 4px;
      &.total-item {
        ::v-deep .el-form-item__label {
          line-height: 38px;
        }
      }
      .total {
        font-size: 30px;
        font-weight: 600;
        color: #ff4433;
        line-height: 38px;
        em {
          font-size: 16px;
          font-weight: 400;
          color: #ff4e33;
          line-height: 28px;
        }
      }
      ::v-deep .el-form-item__label {
        font-size: 16px;
        line-height: 28px;
        color: #595959;
      }
      ::v-deep .el-form-item__content {
        font-size: 16px;
        line-height: 28px;
        color: #262626;
      }
    }
  }
  .serverFromFooter {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    ::v-deep .el-checkbox__inner {
      border-radius: 50%;
    }
    .el-link.el-link--primary {
      color: #3b9bff;
      &:hover {
        color: #fd9b21;
      }
    }
    .el-button {
      width: 200px;
      height: 50px;
      font-size: 20px;
      // line-height: 28px;
      font-weight: bold;
      margin: 0 30px;
    }
  }
  .tip-title {
    font-size: 24px;
    .icon {
      color: #fd9b21;
      margin-right: 10px;
    }
  }
  .tip-contnet {
    font-size: 18px;
    .p {
      text-indent: 2em;
    }
  }
}
</style>
